import * as actionTypes from 'constants/ActionTypes';

export function getSubscribers(data) {
    return {
        type: actionTypes.GET_SUBSCRIBERS.REQUEST,
        data,
    };
}



// WEBPACK FOOTER //
// ./app/actions/users/subscribers.js